/* /tdb/bundles · Bundle BOM page */
import { useEffect, useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import TDBBundleBOM from '@/components/TDBBundleBOM';


export default function TDBBundleBOMPage() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get('/auth/me');
        setUser(r.data?.user || r.data);
      } catch (e) {
        navigate('/login');
      }
    })();
  }, [navigate]);

  return (
    <div data-testid="tdb-bundle-bom-page" className="min-h-screen bg-slate-50">
      <div className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-3">
          <button
            data-testid="tdb-bb-back-btn"
            onClick={() => navigate('/division/tdb')}
            className="text-slate-600 hover:text-slate-900 flex items-center gap-1 text-sm"
          >
            <ChevronLeft className="w-4 h-4" /> Back to TDB
          </button>
          <div className="h-6 w-px bg-slate-200" />
          <h1 className="text-base font-semibold text-slate-900">Bundle BOM</h1>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-6">
        {user && <TDBBundleBOM currentUser={user} />}
      </div>
    </div>
  );
}
